import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {deleteReq, fetchData, fetchDataNew, fetchList} from "../../../hook/axios.hook";
import {checkEmptyFields} from "../../../utilities/checkEmptyFields";

const initialState = {
  // planSkuList: null,
  planSkuList: [],
  currentSkuPlan: null,

  uploadedOverallView: [],
  addedOverallView: [],
  addedImages: [],
  addedColorImages: [],
  addedDecorImages: [],

  allCOfs: [],
  currentCOf: null,

  allCOas: [],
  currentCOa: null,

  discounts: [],
  discountInfo: [],

  services: [],
  serviceTypes: [],

  kpFLoadingStatus: false,
  imgLoading: false,
};

export const fetchSkuPlanListForKpf = createAsyncThunk("sku/fetchSkuPlanListForKpf", async cofId => {
  const responce = fetchList(`/skuPlan/getForCof/${cofId}`, "get");

  return responce;
});
// export const fetchSkuPlanInfo = createAsyncThunk(
//     'sku/fetchSkuPlanInfo',
//     async (skuPlanId) => {
//         return fetchData(`/sku/get/${skuPlanId}`,'get')
//     }
// );

export const addSkuToKpF = createAsyncThunk("sku/addSkuToKpF", async ({cofId, idealSkuId, skuPlan}) => {
  var plan = checkEmptyFields(skuPlan);

  return fetchData(`/skuPlan/add/${idealSkuId}/${cofId}`, "post", plan);
});

export const addSkuToKpFV2 = createAsyncThunk("skuPlanV2/createSkuPlan", async ({skuId, cofId, isRejected = 0}) => {
  return fetchDataNew(`v2/skuPlan/${skuId}/${cofId}`, "post", {params: {isRejected: isRejected ? 1 : 0}});
});

export const getSkuPlanInfo = createAsyncThunk("sku/getSkuPlanInfo", async skuPlanId => {
  return fetchData(`/skuPlan/get/${skuPlanId}`, "get");
});

export const getSkuPlanInfoV2 = createAsyncThunk("skuPlanV2/getSkuPlanById", async skuPlanId => {
  return fetchDataNew(`v2/skuPlan/${skuPlanId}`, "get");
});

export const updateSkuPlan = createAsyncThunk("sku/updateSkuPlan", async ({skuPlanId, skuPlan}) => {
  // var plan = checkEmptyFields(skuPlan);

  return fetchData(`/skuPlan/update/${skuPlanId}`, "patch", skuPlan);
});
export const updateSkuPlanV2 = createAsyncThunk("skuPlanV2/updateSkuPlan", async ({skuPlanId, ...body}) => {
  return fetchDataNew(`v2/skuPlan/${skuPlanId}`, "patch", {body});
});

export const delSkuPlan = createAsyncThunk("sku/delSkuPlan", async skuPlanId => {
  return deleteReq(`/skuPlan/delete/${skuPlanId}`, "delete");
});
export const delSkuPlanV2 = createAsyncThunk("skuPlanV2/deleteSkuPlan", async skuPlanId => {
  return fetchDataNew(`v2/skuPlan/${skuPlanId}`, "delete").then(() => skuPlanId);
});

export const addSkuPlanDoc = createAsyncThunk("sku/addSkuPlanDoc", async ({cofId, formData}) => {
  return fetchData(`/cos/f/docs/add/${cofId}`, "put", formData);
});

//price change

export const updateSkuPlanCoef = createAsyncThunk("skuPlan/updateCoef", async ({skuPlanId, coeficients}) => {
  return fetchData(`/skuPlan/update/${skuPlanId}?isCoefUpdate=1`, "patch", coeficients);
});

//
export const changeSequenceNumber = createAsyncThunk("sku/changeSequenceNumber", async ({sequenceObject}) => {
  return fetchData(`/skuPlan/reorder`, "patch", sequenceObject);
});
export const changeSequenceNumberV2 = createAsyncThunk(
  "skuPlanV2/reorderSkuPlan",
  async ({cofId, body, isRejected}) => {
    return fetchDataNew(`v2/skuPlan/reorder/${cofId}`, "patch", {body, params: {isRejected: isRejected ? 1 : 0}});
  },
);

export const uploadOverallImage = createAsyncThunk("sku/uploadOverallImage", async ({skuPlanId, formdata}) => {
  const responce = fetchData(`/skuPlan/overallView/upload/${skuPlanId}`, "put", formdata);
  return responce;
});

export const delOverallImage = createAsyncThunk("sku/delOverallImages", async imageId => {
  const responce = deleteReq(`/skuPlan/overallView/delete/${imageId}`);
  return responce;
});

export const addOverallImage = createAsyncThunk("sku/addOverallImage", async imageId => {
  return fetchData(`/skuPlan/overallView/add/${imageId}`, "patch");
});

export const removeOverallImage = createAsyncThunk("sku/removeOverallImage", async imageId => {
  return fetchData(`/skuPlan/overallView/remove/${imageId}`, "patch");
});

export const addCommonImage = createAsyncThunk("sku/addImage", async ({imageId, skuPlanId, imageType}) => {
  return fetchData(`/skuPlan/image/add/${imageId}/${skuPlanId}?imageType=${imageType}`, "patch");
});

export const removeCommonImage = createAsyncThunk("sku/removeImage", async ({imageId, skuPlanId, imageType}) => {
  return fetchData(`/skuPlan/image/remove/${imageId}/${skuPlanId}?imageType=${imageType}`, "patch");
});

export const addColorImage = createAsyncThunk("sku/addColorImage", async ({imageId, skuPlanId}) => {
  return fetchData(`/skuPlan/colorImage/add/${imageId}/${skuPlanId}`, "patch");
});

export const removeColorImage = createAsyncThunk("sku/removeColorImage", async ({imageId, skuPlanId}) => {
  return fetchData(`/skuPlan/colorImage/remove/${imageId}/${skuPlanId}`, "patch");
});

export const addDecorImage = createAsyncThunk("sku/addDecorImage", async ({imageId, skuPlanId}) => {
  return fetchData(`/skuPlan/decorImage/add/${imageId}/${skuPlanId}`, "patch");
});

export const removeDecorImage = createAsyncThunk("sku/removeDecorImage", async ({imageId, skuPlanId}) => {
  return fetchData(`/skuPlan/decorImage/remove/${imageId}/${skuPlanId}`, "patch");
});
//***SKU Plan V2 */

export const uploadImagePlanSku = createAsyncThunk("skuPlanV2/uploadImages", async ({skuPlanId, imageType, body}) => {
  return fetchDataNew(`v2/skuPlan/${skuPlanId}/images/${imageType}`, "put", {body});
});
export const updateImagePlanSku = createAsyncThunk("skuPlanV2/updateImages", async ({imageId, ...body}) => {
  return fetchDataNew(`v2/skuPlan/images/${imageId}`, "patch", {body});
});
export const removeImagePlanSku = createAsyncThunk("skuPlanV2/removeImages", async imageId => {
  return fetchDataNew(`v2/skuPlan/images/${imageId}`, "delete").then(() => imageId);
});

//*** CO(f) new*/
export const fetchAllCOfs = createAsyncThunk("cof/fetchAllCOfs", async ({coId}) =>
  fetchList("/cos/f/getAll", "get", {params: {coId}}),
);
export const fetchCOf = createAsyncThunk("cof/fetchCOf", async ({cofId}) => fetchData(`/cos/f/get/${cofId}`, "get"));
export const addCOf = createAsyncThunk("cof/addCOf", async ({coId}) =>
  fetchDataNew(`/cos/f/add/${coId}`, "post", {noMessage: true}),
);
export const dublicateCOf = createAsyncThunk("cof/dublicateCOf", async ({cofId}) =>
  fetchData(`/kp/f/duplicate/${cofId}`, "post"),
);
export const updateCOf = createAsyncThunk("cof/updateCOf", async ({cofId, body, isRejected}) =>
  fetchDataNew(`/cos/f/update/${cofId}`, "patch", {params: {isRejected: isRejected ? 1 : 0}, body}),
);
export const toggleFreezeCOf = createAsyncThunk("cof/toggleFreezeCOf", async ({cofId, freezedInfo}) =>
  fetchData(`/cos/f/freeze/${cofId}`, "patch", {freezedInfo}),
);
export const deleteCOf = createAsyncThunk("cof/delCOf", async ({cofId}) =>
  fetchData(`/cos/f/remove/${cofId}`, "delete"),
);

//*** CO(a) new*/
export const fetchAllCOas = createAsyncThunk("coa/fetchAllCOas", async ({coId}) =>
  fetchList(`/kp/a/getForCo/${coId}`, "get"),
);
export const fetchCOa = createAsyncThunk("coa/fetchCOa", async ({coaId}) => fetchData(`/kp/a/get/${coaId}`, "get"));
export const addCOa = createAsyncThunk("coa/addCOa", async ({coId, body}) =>
  fetchData(`/kp/a/add/${coId}`, "post", body),
);
export const updateCOa = createAsyncThunk("coa/updateCOa", async ({coaId, body}) =>
  fetchData(`/kp/a/update/${coaId}`, "patch", body),
);
export const deleteCOa = createAsyncThunk("coa/deleteCOa", async ({coaId}) =>
  fetchData(`/kp/a/delete/${coaId}`, "delete"),
);

//***  discounts
export const fetchAllCOfDiscounts = createAsyncThunk("kpf/discounts/fetchAllCOfDiscounts", async ({cofId}) =>
  fetchList(`/cos/f/discounts/${cofId}`, "get"),
);
export const fetchCOfDiscountInfo = createAsyncThunk("kpf/discounts/fetchCOfDiscountInfo", async ({cofId}) =>
  fetchList(`/cos/f/discounts/info/${cofId}`, "get"),
);
export const addNewCOfDiscount = createAsyncThunk(
  "kpf/discounts/addNewCOfDiscount",
  async ({cofId, factoryId, discountValue, typeId}) =>
    fetchData(`/cos/f/discounts/${cofId}`, "post", {factoryId, discountValue, typeId}),
);
export const deleteCOfDiscount = createAsyncThunk("kpf/discounts/deleteCOfDiscount", async ({discountId}) =>
  fetchData(`/cos/f/discounts/${discountId}`, "delete"),
);
export const deleteCOfDiscounts = createAsyncThunk("kpf/discounts/deleteCOfDiscounts", async ({discountIds}) =>
  deleteReq(`/cos/f/discounts/remove`, {ids: discountIds}),
);

//***Services */
export const fetchAllCOfServices = createAsyncThunk("kpf/services/fetchAllCOfServices", async ({cofId}) =>
  fetchList(`/cos/f/services/${cofId}`, "get"),
);
export const fetchCOfServiceTypes = createAsyncThunk("kpf/services/fetchCOfServiceTypes", async () =>
  fetchList(`/cos/f/services/types`, "get"),
);
export const addNewCOfService = createAsyncThunk(
  "kpf/services/addNewCOfService",
  async ({cofId, typeId, serviceCost}) => fetchData(`/cos/f/services/${cofId}`, "post", {typeId, serviceCost}),
);
export const deleteCOfService = createAsyncThunk("kpf/services/deleteCOfService", async ({serviceId}) =>
  fetchData(`/cos/f/services/${serviceId}`, "delete"),
);
export const deleteCOfServices = createAsyncThunk("kpf/services/deleteCOfServices", async ({serviceIds}) =>
  deleteReq(`/cos/f/services/remove`, {ids: serviceIds}),
);

const kpfSlice = createSlice({
  name: "kpf",
  initialState,
  reducers: {
    deselect: state => {
      state.currentSkuPlan = null;
      state.uploadedOverallView = [];
    },
    clearCurrentCof: state => {
      state.currentCOf = null;
    },
    clearAllCofs: state => {
      state.allCOfs = [];
    },
    clearCurrentCoa: state => {
      state.currentCOa = null;
    },
    clearAllCoas: state => {
      state.allCOas = [];
    },
    clearCofServices: state => {
      state.services = [];
    },
    clearCurrentSkuPlan: state => {
      state.currentSkuPlan = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSkuPlanListForKpf.pending, state => {
        state.kpFLoadingStatus = true;
      })
      .addCase(fetchSkuPlanListForKpf.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.kpFLoadingStatus = false;

        // state.planSkuList = payload.skuPlanList;
        state.planSkuList = payload;

        state.currentSkuPlan = null;
        state.uploadedOverallView = [];
      })

      .addCase(addSkuToKpF.fulfilled, (state, {payload}) => {
        if (!payload || !payload.skuPlan) {
          return;
        }

        state.planSkuList?.push(payload.skuPlan);
        const {uploadedOverallView, ...skuPlan} = payload.skuPlan;
        state.currentSkuPlan = skuPlan;
        state.uploadedOverallView = uploadedOverallView;
        state.addedOverallView = skuPlan.addedOverallView;
        state.addedImages = skuPlan.addedImages;
        state.addedColorImages = skuPlan.addedColorImages;
        state.addedDecorImages = skuPlan.addedDecorImages;
      })

      .addCase(getSkuPlanInfo.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const {uploadedOverallView, ...rest} = payload;
        state.currentSkuPlan = {...rest};
        state.uploadedOverallView = uploadedOverallView;
        state.addedOverallView = rest?.addedOverallView;
        state.addedImages = rest?.addedImages;
        state.addedColorImages = rest?.addedColorImages;
        state.addedDecorImages = rest?.addedDecorImages;
      })
      .addCase(updateSkuPlan.fulfilled, (state, {payload}) => {
        if (!payload) return;

        const {uploadedOverallView, ...skuPlan} = payload.skuPlan;
        state.currentSkuPlan = skuPlan;
        state.uploadedOverallView = uploadedOverallView;
        state.addedOverallView = skuPlan.addedOverallView;
        state.addedImages = skuPlan.addedImages;
        state.addedColorImages = skuPlan.addedColorImages;
        state.addedDecorImages = skuPlan.addedDecorImages;

        state.planSkuList = state.planSkuList?.map(plan => {
          if (plan.skuPlanId === payload.skuPlan?.skuPlanId) {
            return payload.skuPlan;
          }
          return plan;
        });
      })
      .addCase(delSkuPlan.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.planSkuList = payload.skuPlanList;

        state.currentSkuPlan = null;
        state.uploadedOverallView = [];
        state.currentCOf.skuPlan = payload.skuPlanList;
      })
      .addCase(changeSequenceNumber.fulfilled, (state, {payload}) => {
        console.log(payload);
      })
      .addCase(uploadOverallImage.pending, (state, {payload}) => {
        state.imgLoading = true;
      })
      .addCase(uploadOverallImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.uploadedOverallView = payload.uploadedOverallView;
        state.imgLoading = false;
      })
      .addCase(delOverallImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.uploadedOverallView = payload.uploadedOverallView;
      })
      .addCase(addOverallImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedOverallView = payload.addedOverallView;
      })
      .addCase(removeOverallImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedOverallView = payload.addedOverallView;
      })
      .addCase(addCommonImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedImages = payload.addedImages;
      })
      .addCase(removeCommonImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedImages = payload.addedImages;
      })
      .addCase(addColorImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedColorImages = payload.addedColorImages;
      })
      .addCase(removeColorImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedColorImages = payload.addedColorImages;
      })
      .addCase(addDecorImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedDecorImages = payload.addedDecorImages;
      })
      .addCase(removeDecorImage.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.addedDecorImages = payload.addedDecorImages;
      })

      //*** CO(f) new*/
      .addCase(fetchAllCOfs.pending, (state, {payload}) => {
        if (!payload) return;

        state.kpFLoadingStatus = true;
        state.allCOfs = payload;
      })
      .addCase(fetchAllCOfs.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.kpFLoadingStatus = false;
        state.allCOfs = payload;
      })
      .addCase(fetchCOf.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.currentCOf = payload;
        state.planSkuList = payload.skuPlan;
      })
      .addCase(addCOf.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.currentCOf = payload.cof;
      })
      .addCase(updateCOf.fulfilled, (state, {payload}) => {
        if (!payload) return;
        state.currentCOf = payload.cof;
      })
      .addCase(toggleFreezeCOf.fulfilled, (state, {payload}) => {
        state.currentCOf = payload;
      })
      .addCase(deleteCOf.fulfilled, state => {
        state.currentCOf = null;
      })

      //*** CO(a) new*/
      .addCase(fetchAllCOas.fulfilled, (state, {payload}) => {
        state.allCOas = payload;
      })
      .addCase(fetchCOa.fulfilled, (state, {payload}) => {
        state.currentCOa = payload;
      })
      .addCase(addCOa.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentCOa = payload.coa;
      })
      .addCase(updateCOa.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentCOa = payload.coa;
      })
      .addCase(deleteCOa.fulfilled, state => {
        state.currentCOa = null;
      })

      //***  discounts
      .addCase(fetchAllCOfDiscounts.fulfilled, (state, {payload}) => {
        state.discounts = payload;
      })
      .addCase(fetchCOfDiscountInfo.fulfilled, (state, {payload}) => {
        state.discountInfo = payload;
      })

      //***Services */
      .addCase(fetchAllCOfServices.fulfilled, (state, {payload}) => {
        state.services = payload;
      })
      .addCase(fetchCOfServiceTypes.fulfilled, (state, {payload}) => {
        state.serviceTypes = payload;
      })
      .addCase(addNewCOfService.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.services = [...state.services, payload];
      })
      .addCase(deleteCOfService.fulfilled, (state, {meta}) => {
        state.services = state.services?.filter(({serviceId}) => !meta?.arg?.serviceId !== serviceId);
      })
      .addCase(deleteCOfServices.fulfilled, (state, {meta}) => {
        state.services = state.services.filter(({serviceId}) => !meta.arg.serviceIds?.includes(serviceId));
      })

      .addCase(updateSkuPlanCoef.fulfilled, (state, {payload}) => {
        if (!payload) return;

        state.currentSkuPlan = {...state.currentSkuPlan, skuPlanPrice: payload.skuPlan?.skuPlanPrice};
      })
      //**SKU Plan V2 */
      .addCase(getSkuPlanInfoV2.pending, handlePending)
      .addCase(getSkuPlanInfoV2.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imgLoading = false;
          return;
        }
        state.currentSkuPlan = payload;
        state.imgLoading = false;
      })
      .addCase(getSkuPlanInfoV2.rejected, handleRejected)
      .addCase(addSkuToKpFV2.pending, handlePending)
      .addCase(addSkuToKpFV2.fulfilled, (state, {payload}) => {
        if (!payload?.skuPlan) {
          state.imgLoading = false;
          return;
        }
        const {skuPlan} = payload;
        state.planSkuList.push(skuPlan);
        state.currentSkuPlan = skuPlan;
        state.imgLoading = false;
      })
      .addCase(addSkuToKpFV2.rejected, handleRejected)
      .addCase(updateSkuPlanV2.pending, handlePending)
      .addCase(updateSkuPlanV2.fulfilled, (state, {payload}) => {
        if (!payload?.skuPlan) {
          state.imgLoading = false;
          return;
        }
        const {skuPlan} = payload;
        state.currentSkuPlan = skuPlan;
        state.planSkuList = state.planSkuList?.map(plan => {
          if (plan.skuPlanId === skuPlan.skuPlanId) {
            return payload.skuPlan;
          }
          return plan;
        });
        state.imgLoading = false;
      })
      .addCase(updateSkuPlanV2.rejected, handleRejected)
      .addCase(delSkuPlanV2.pending, handlePending)
      .addCase(delSkuPlanV2.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imgLoading = false;
          return;
        }
        state.planSkuList = state.planSkuList.filter(({skuPlanId}) => skuPlanId !== payload);
        state.imgLoading = false;
      })
      .addCase(delSkuPlanV2.rejected, handleRejected)
      .addCase(uploadImagePlanSku.pending, handlePending)
      .addCase(uploadImagePlanSku.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imgLoading = false;
          return;
        }
        state.currentSkuPlan.images.push(payload);

        state.imgLoading = false;
      })
      .addCase(uploadImagePlanSku.rejected, handleRejected)
      .addCase(updateImagePlanSku.pending, handlePending)
      .addCase(updateImagePlanSku.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imgLoading = false;
          return;
        }

        const index = state.currentSkuPlan.images?.findIndex(({imageId}) => imageId === payload.imageId);
        if (index !== -1) state.currentSkuPlan.images[index] = payload;
        state.imgLoading = false;
      })
      .addCase(updateImagePlanSku.rejected, handleRejected)
      .addCase(removeImagePlanSku.pending, handlePending)
      .addCase(removeImagePlanSku.fulfilled, (state, {payload}) => {
        if (!payload) {
          state.imgLoading = false;
          return;
        }
        state.currentSkuPlan.images = state.currentSkuPlan.images?.filter(({imageId}) => imageId !== payload);
        state.imgLoading = false;
      })
      .addCase(removeImagePlanSku.rejected, handleRejected)

      .addDefaultCase(() => {});
  },
});

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}

const {actions, reducer} = kpfSlice;

export default reducer;
export const {
  deselect,
  clearOverall,
  clearCurrentCof,
  clearAllCofs,
  clearAllCoas,
  clearCurrentCoa,
  clearCofServices,
  clearCurrentSkuPlan,
} = actions;

export const getPlanSkuList = state => state.kpf.planSkuList;
export const getCurrentSkuPlan = state => state.kpf.currentSkuPlan;
export const getCurrentUploadedOverallView = state => state.kpf.uploadedOverallView;
export const getAddedOverallView = state => state.kpf.addedOverallView;
export const getAddedImages = state => state.kpf.addedImages;
export const getAddedColorImages = state => state.kpf.addedColorImages;
export const getAddedDecorImages = state => state.kpf.addedDecorImages;

export const getKpFLoading = state => state.kpf.kpFLoadingStatus;
export const getImgLoading = state => state.kpf.imgLoading;

export const selectAllCofs = state => state.kpf.allCOfs;
export const selectCurrentCof = state => state.kpf.currentCOf;

export const selectAllCoas = state => state.kpf.allCOas;
export const selectCurrentCoa = state => state.kpf.currentCOa;

export const selectAllCOfDiscounts = state => state.kpf.discounts;
export const selectCOfDiscountInfo = state => state.kpf.discountInfo;

export const selectAllCOfServices = state => state.kpf.services;
export const selectCOfServiceTypes = state => state.kpf.serviceTypes;
